import { Component } from '@angular/core';

@Component({
  selector: 'app-page-sobre',
  templateUrl: './page-sobre.component.html',
  styleUrls: ['./page-sobre.component.scss'],
})
export class PageSobreComponent {}
